import Footer from "../components/Footer";

export default function AboutPage({ onNav }) {
  return (
    <div className="page-top-pad" style={{ background:"white", minHeight:"100vh" }}>
      <div style={{ background:"linear-gradient(135deg,#1a1a2e,#2d1b69)", padding:"clamp(36px,6vw,56px) clamp(16px,4vw,40px)", textAlign:"center" }}>
        <div style={{ fontFamily:"'Noto Serif Devanagari',serif", fontSize:"clamp(26px,4vw,38px)", fontWeight:900, color:"white", marginBottom:8 }}>मॅचवेल</div>
        <p style={{ fontSize:12, letterSpacing:3, textTransform:"uppercase", color:"#EC4899", fontWeight:700 }}>Est. 1979 · Chhatrapati Sambhajinagar</p>
      </div>

      <div style={{ maxWidth:760, margin:"0 auto", padding:"clamp(28px,5vw,52px) clamp(16px,4vw,40px)" }}>
        <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(20px,3vw,28px)", fontWeight:800, color:"#1a1a2e", marginBottom:16 }}>Our Story</h2>
        <p style={{ fontSize:14, color:"#555", lineHeight:1.9, marginBottom:24 }}>
          Matchwell began in 1979 as a small fabric counter at Gulmandi Corner, in the heart of Chhatrapati Sambhajinagar
          (Aurangabad). Over four decades, three generations of the same family have grown it into a full ladies' clothing
          showroom — spanning three floors and serving thousands of women across the city and beyond.
        </p>
        <p style={{ fontSize:14, color:"#555", lineHeight:1.9, marginBottom:24 }}>
          What hasn't changed is our approach: hand-picked fabrics, honest pricing, and the kind of personal attention you'd
          expect walking into a shop where the owners know your name. This website is our way of bringing that same
          experience online — so whether you visit us in person or shop from home, it feels like Matchwell.
        </p>

        <div style={{ display:"grid", gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))", gap:16, margin:"32px 0" }}>
          {[["1979","Founded"],["3","Floors of Fashion"],["3","Generations"],["60+","Team Members"]].map(([v,l])=>(
            <div key={l} style={{ textAlign:"center", background:"#fafafa", borderRadius:14, padding:20 }}>
              <div style={{ fontFamily:"'Playfair Display',serif", fontSize:26, fontWeight:900, color:"#EC4899" }}>{v}</div>
              <div style={{ fontSize:11, color:"#999", marginTop:4, textTransform:"uppercase", letterSpacing:1 }}>{l}</div>
            </div>
          ))}
        </div>

        <h2 style={{ fontFamily:"'Playfair Display',serif", fontSize:"clamp(20px,3vw,28px)", fontWeight:800, color:"#1a1a2e", marginBottom:16, marginTop:32 }}>Visit Us</h2>
        <p style={{ fontSize:14, color:"#555", lineHeight:1.9, marginBottom:20 }}>
          Gulmandi Corner, Chhatrapati Sambhajinagar, Maharashtra 431001 — open every day, 10 AM to 9 PM.
        </p>
        <button onClick={()=>onNav("contact")} style={{ background:"#EC4899", color:"white", border:"none", padding:"12px 28px", borderRadius:50, fontSize:13, fontWeight:700, cursor:"pointer" }}>
          Get in Touch
        </button>
      </div>
      <Footer onNav={onNav}/>
    </div>
  );
}
